import { useCallback } from 'react';

import { Guide } from '../guide';
import { Step } from '../guide/types';

export const ComboGuide = ({
  steps,
  onClose,
  onFinish,
  initialStepIndex = 0,
}: {
  onClose: VoidFunction;
  onFinish: VoidFunction;
  steps: Step[];
  initialStepIndex?: number;
}) => {
  return (
    <Guide
      onRequestClose={onClose}
      steps={steps}
      initialStepIndex={initialStepIndex}
      onGuideFinish={useCallback(() => {
        onFinish();
      }, [onFinish])}
    />
  );
};
